module.exports = __webpack_public_path__ + "static/city_icon_53-e95ea590fa492f4974a21abfca53340f.png";